import axios from 'axios'
import { useAuthStore } from '@/plugins/w/auth/store/auth.store'
import { merge } from 'lodash'

axios.defaults.baseURL = import.meta.env.VITE_APP_AXIOS_URL

export default {
	async get(url: string, config?: any) {
		return axios
			.get(url, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async get_auth(url: string, config?: any) {
		config = this._config(config)

		return axios
			.get(url, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async get_data(url: string, config?: any) {
		return axios
			.get(url, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async get_auth_data(url: string, config?: any) {
		config = this._config(config)

		return axios
			.get(url, config)
			.then((response) => Promise.resolve(response.data.data))
			.catch((error) => Promise.reject(error.response))
	},

	async post(url: string, params = null, config?: any) {
		return axios
			.post(url, params, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async post_auth(url: string, params = null, config?: any) {
		config = this._config(config)

		return axios
			.post(url, params, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async post_data(url: string, params = null, config?: any) {
		return axios
			.post(url, params, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async post_auth_data(url: string, params = null, config?: any) {
		config = this._config(config)

		return axios
			.post(url, params, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async post_auth_form_data(url: string, params = null, config?: any) {
		config = this._config(config)

		const formData = this._objectToFormData(params)
		// formData.append('_method', 'PATCH');

		return axios
			.post(url, formData, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async delete(url: string, config?: any) {
		return axios
			.delete(url, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async delete_auth(url: string, config?: any) {
		config = this._config(config)

		return axios
			.delete(url, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async delete_data(url: string, config?: any) {
		return axios
			.delete(url, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async delete_auth_data(url: string, config?: any) {
		config = this._config(config)

		return axios
			.delete(url, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async patch(url: string, params = null, config?: any) {
		return axios
			.patch(url, params, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async patch_auth(url: string, params = null, config?: any) {
		config = this._config(config)

		return axios
			.patch(url, params, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async patch_data(url: string, params = null, config?: any) {
		return axios
			.patch(url, params, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async patch_auth_data(url: string, params = null, config?: any) {
		config = this._config(config)

		return axios
			.patch(url, params, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async patch_auth_form_data(url: string, params = null, config?: any) {
		config = this._config(config)

		const formData = this._objectToFormData(params)
		formData.append('_method', 'PATCH')

		return axios
			.post(url, formData, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async put(url: string, params = null, config?: any) {
		return axios
			.put(url, params, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async put_auth(url: string, params = null, config?: any) {
		config = this._config(config)

		return axios
			.put(url, params, config)
			.then((response) => response.data)
			.catch((error) => Promise.reject(error))
	},

	async put_data(url: string, params = null, config?: any) {
		return axios
			.put(url, params, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	async put_auth_data(url: string, params = null, config?: any) {
		config = this._config(config)

		return axios
			.put(url, params, config)
			.then((response) => response.data.data)
			.catch((error) => Promise.reject(error.response))
	},

	_config(config: any) {
		const authStore = useAuthStore()

		const defaultConfig = {
			headers: {
				Authorization: `Bearer ${authStore.getToken}`
			}
		}

		return merge(defaultConfig, config)
	},

	_objectToFormData(obj, form, namespace) {
		let formData = form || new FormData()
		let formKey

		for (let property in obj) {
			if (obj.hasOwnProperty(property)) {
				if (namespace) {
					formKey = namespace + '[' + property + ']'
				} else {
					formKey = property
				}

				// if the property is an object, but not a Blob, use recursivity.
				if (typeof obj[property] === 'object' && !(obj[property] instanceof Blob)) {
					this._objectToFormData(obj[property], formData, formKey)
				} else {
					// if it's a string or a Blob object
					if (obj[property] instanceof Blob) {
						formData.append(formKey, obj[property], obj[property].name)
					} else {
						formData.append(formKey, obj[property])
					}
				}
			}
		}

		return formData
	},

	objectToQueryString(object) {
		let params = []

		for (const key in object) {
			this._encodeParams(key, object[key], params)
		}

		return params.join('&')
	},

	_encodeParams(key, value, params) {
		if (Array.isArray(value)) {
			value.forEach((subValue, index) => {
				this._encodeParams(`${key}[${index}]`, subValue, params)
			})
		} else if (typeof value === 'object' && value !== null) {
			for (let subKey in value) {
				this._encodeParams(`${key}[${subKey}]`, value[subKey], params)
			}
		} else {
			params.push(`${key}=${encodeURIComponent(value)}`)
		}
	}
}
